export type TaskData = {
  no: number;
  id: number;
  date: string;
  company: string;
  userName: string;
  length: string;
};

export const RIPENESS_TYPE = {
  UNRIPE: "UNRIPE",
  RIPE: "RIPE",
  OVERRIPE: "OVERRIPE",
  ROTTEN: "ROTTEN",
};

export type RipenessType = (typeof RIPENESS_TYPE)[keyof typeof RIPENESS_TYPE];

export const RIPENESS_VIEW_TYPE = {
  UNRIPE: "Mentah",
  RIPE: "Matang",
  OVERRIPE: "Lewat Matang",
  ROTTEN: "Busuk",
};

export const LABEL_TYPE = {
  PASS: "PASS",
  FAIL1: "FAIL1",
  FAIL2: "FAIL2",
  FAIL3: "FAIL3",
};

export type LabelType = (typeof LABEL_TYPE)[keyof typeof LABEL_TYPE];

export const LABEL_VIEW_TYPE = {
  PASS: "Pass",
  FAIL1: "Fail",
  FAIL2: "Gagal 2",
  FAIL3: "Gagal 3",
};
